import bgHeader from '@/assets/images/pngs/bg-header.png';
import { cn } from '@/utils/utils';
import { ArrowLeft } from 'lucide-react';

interface HeaderProps {
    goBackFunction: Function,
    title: string,
    className?: string,
    iconRight?: string,
    iconRightFunction?: Function
}

const Header = ({ goBackFunction, title, className, iconRight, iconRightFunction = () => { } }: HeaderProps) => {
    return (
        <div className={cn('fixed top-0 left-0 z-50 h-[72px] w-full', className)}>
            <img src={bgHeader} alt='bgHeader' className='w-full h-full object-cover' />
            <ArrowLeft
                onClick={() => goBackFunction()}
                size={24}
                className='absolute top-6 left-4 text-white z-50 cursor-pointer'
            />
            <div className='w-full absolute top-6 text-center'>
                <p className=' text-white text-[17px] font-semibold'>{title}</p>
            </div>
            {iconRight && (
                <img
                    src={iconRight}
                    alt='iconRight'
                    onClick={() => iconRightFunction()}
                    className='absolute w-6 h-6 top-6 right-4 text-white z-50 cursor-pointer'
                />
            )}
        </div>
    );
};

export default Header;
